import {
  InfoIcon,
  UsersIcon,
  Quote,
  Phone,
  MessageCircle,
  Sprout,
  Network,
  Layers,
  Briefcase,
  Handshake,
  BarChart3,
  Workflow,
  Lightbulb,
  HomeIcon,
} from "lucide-react";
import Home from "../pages/home/Home";
import Service from "../pages/service/serviceListing/Service";
import About from "../pages/about/About";
import Team from "../pages/teams/team";
import Testimonial from "../pages/testimonial/Testimonial";
import Contact from "../pages/contact/contact";
import Enquiry from "../pages/Enquiry/enquiry";
import LookingForChange from "../pages/lookingForChange/lookingForChange";
import Industry from "../pages/industry/industryListing/industry";
import IndustryDetail from "../pages/industry/industryDetail/industry";
import ServiceDetail from "../pages/service/serviceDetail/serviceDetail";
import Insight from "../pages/insight/insight";
import Profile from "../pages/profile/Profile";

export interface AppRoute {
  key: string;
  label: string;
  url: string;
  icon?: React.ComponentType<any>;
  component?: React.ComponentType;
  children?: AppRoute[];
  hidden?: boolean;
  ignore?: number;
  type?: string;
}

const routes: AppRoute[] = [
  {
    key: "1",
    label: "Home",
    url: "/",
    icon: HomeIcon,
    component: Home,
  },
  {
    key: "2",
    label: "About",
    url: "/about",
    icon: InfoIcon,
    component: About,
  },
  {
    key: "3",
    label: "Our Team",
    url: "/team",
    icon: UsersIcon,
    component: Team,
  },
  {
    key: "5",
    label: "Service",
    url: "/service",
    icon: Handshake,
    children: [
      {
        key: "5-1",
        label: "Service Listing",
        url: "/",
        icon: BarChart3,
        component: Service,
      },
      {
        key: "5-2",
        label: "Service Detail",
        icon: Workflow,
        url: "/detail",
        component: ServiceDetail,
      },
    ],
  },
  {
    key: "6",
    label: "Industry",
    url: "/industry",
    icon: Network,
    children: [
      {
        key: "6-1",
        label: "Industry Listing",
        url: "/",
        icon: Layers,
        component: Industry,
      },
      {
        key: "6-2",
        label: "Industry Detail",
        url: "/detail",
        icon: Briefcase,
        component: IndustryDetail,
      },
    ],
  },

  {
    key: "7",
    label: "Insight",
    url: "/insight",
    icon: Lightbulb,
    component: Insight,
  },

  {
    key: "8",
    label: "Testimonial",
    url: "/testimonial",
    icon: Quote,
    component: Testimonial,
  },
  {
    key: "9",
    label: "Contact Us",
    url: "/contact",
    icon: Phone,
    component: Contact,
  },
  {
    key: "10",
    label: "Looking for a Change?",
    url: "/looking-for-a-change",
    icon: Sprout,
    component: LookingForChange,
  },

  {
    key: "11",
    label: "Enquiry",
    url: "/enquiry",
    icon: MessageCircle,
    component: Enquiry,
  },
  {
    key: "12",
    label: "Profile",
    url: "/profile",
    icon: UsersIcon,
    component: Profile,
  },
];

export default routes;
